module.exports = __webpack_public_path__ + "static/media/icon-discount.540b3515.svg";